<style lang="less" scoped src="../css/common.less"></style>
<style lang="less" scoped>

</style>
<template>
    <div class="wrap">
        <h2 class="text-center">实习生推荐奖详情</h2>
        <div v-if="topic.id">
            <div class="line">
                <div class="label">发放名称</div>
                <div class="value">{{topic.name || '-'}}</div>
            </div>
            <div class="line">
                <div class="label">发放月份</div>
                <div class="value">{{topic.delivery_month || '-'}}</div>
            </div>
            <div class="line">
                <div class="label">申请人</div>
                <div class="value">{{topic.apply_user || '-'}}</div>
            </div>
            <div class="line">
                <div class="label">发放公司</div>
                <div class="value">{{company_name}}</div>
            </div>
            <div class="line">
                <div class="label">发放总金额</div>
                <div class="value">{{`¥ ${$util.formatPrice(topic.total_price)}`}}</div>
            </div>
            <div class="line" v-if="topic.rec_award_records">
                <div class="label">详情列表</div>
                <div class="value">
                    <table class="mis-table">
                        <tr>
                            <th>推荐人</th>
                            <th>推荐人支付宝账号</th>
                            <th>收款账户核验</th>
                            <th>被推荐人</th>
                            <th>费用所属团队</th>
                            <th width="100">奖金</th>
                        </tr>
                        <tr v-for="(record, index) in topic.rec_award_records" :key="index">
                            <td>{{record.referrer_account}}</td>
                            <td>{{record.bank_number}}</td>
                            <td>{{$util.threeCheckStatusName(record.three_check_status)}}</td>
                            <td>{{record.referee_account}}</td>
                            <td>{{teamName(record.team_id)}}</td>
                            <td>{{`¥ ${$util.formatPrice(record.total_award)}`}}</td>
                        </tr>
                    </table>
                </div>
            </div>

            <div class="line user-flow" v-if="topic.user_flow">
                <div class="label">流程状态</div>
                <div class="value">
                    <UserFlow :user_flow="topic.user_flow"></UserFlow>
                </div>
            </div>
        </div>
        <div class="text-center" v-if="loading">
            <Spin size="large" fix></Spin>
        </div>
    </div>
</template>
<script>
    import ViewerItem from '../item';
    import RecUtil from '../../../rec_award/libs/util';
    import {mapGetters} from "vuex";
    export default {
        components: { ViewerItem },
        props: {
            model_id: {
                type: Number
            }
        },
        data(){
            return {
                topic: {},
                loading: false
            }
        },
        computed: {
            ...mapGetters({
                companies_hash: 'async/companies_hash',
                teams_hash: 'async/root_teams_hash',
            }),
            company_name() {
                const company = this.companies_hash[this.topic.company_id];
                return company ? company.short_name : '未指定';
            },
        },
        created(){
            this.getTopic();
        },
        mounted(){
            //
        },
        methods: {
            getTopic() {
                this.loading = true;
                RecUtil.getTopicDetail(this.model_id).then((data)=>{
                    this.topic = data.topic;
                }).catch((e)=>{
                    this.$Modal.error({title: '错误', content: e.message});
                }).finally(()=>{
                    this.loading = false;
                });
            },
            teamName(team_id) {
                const team = this.teams_hash[team_id];
                return team ? team.name : '未指定';
            }
        }
    }
</script>
